import { render, staticRenderFns } from "./ToRead.vue?vue&type=template&id=73b4130b&"
import script from "./ToRead.vue?vue&type=script&lang=js&"
export * from "./ToRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports